import React, { ReactElement } from 'react';

import { WarningModal } from 'app/components/common';

import styles from '../index.module.scss';

interface Props {
  visible: boolean;
  onClose: () => void;
}

function WarningStillWorkingModal({ visible, onClose }: Props): ReactElement {
  return (
    <WarningModal
      visible={visible}
      onClose={onClose}
      modalClassName={styles.modal}
      header="We are still working on it!"
      text="Your request for Beta Access has not finished processing yet."
    >
      <p>Close this message to return to the homepage</p>
    </WarningModal>
  );
}

export default WarningStillWorkingModal;
